// This file exists to distinguish debug code (console.log) and actually needed logging (consoleLog).
// Developers can find debug code quicker this way.
module.exports = {
    consoleDebug: console.debug,
    consoleLog: console.log,
    consoleWarn: console.warn,
    consoleError: console.error
}